var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',_vm._g(_vm._b({staticClass:"edit-button"},'BaseButton',_vm.$attrs,false),_vm.$listeners),[_c('EditIcon',{staticClass:"fill-current"}),_c('span',{staticClass:"text-base-content font-normal"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }